/** QuotedPreview (06 §4.4) — reply context with sender-colored accent bar. */
import type { Message } from '../../data/model';
import { colorForId } from '../../lib/format';
import styles from './QuotedPreview.module.css';

interface Props {
  senderName: string;
  senderId: string;
  message: Message;
  onClick?: () => void;
  onCancel?: () => void;
}

export function QuotedPreview({ senderName, senderId, message, onClick, onCancel }: Props) {
  const color = colorForId(senderId);
  const snippet = message.deleted
    ? 'This message was deleted'
    : message.media
      ? message.contentType === 'image'
        ? '📷 Photo'
        : message.contentType === 'audio'
          ? '🎤 Voice message'
          : '📄 Document'
      : message.text;
  return (
    <div
      className={styles.quote}
      style={{ borderInlineStartColor: color }}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
    >
      <div className={styles.body}>
        <span className={styles.sender} style={{ color }}>
          {senderName}
        </span>
        <span className={styles.snippet}>{snippet}</span>
      </div>
      {onCancel && (
        <button className={styles.cancel} onClick={onCancel} aria-label="Cancel reply">
          ✕
        </button>
      )}
    </div>
  );
}
